import React from 'react'
import CrewDatePicker from './CrewDatePicker/index'

const CrewExport = () => {
    return (
        <div style={{ padding: "0 10px", marginTop: "10px" }}>
            <CrewDatePicker />
        </div>
    )
}

export default CrewExport